<template>
    <div v-cloak class="main" :style="{background:background}">
        <van-row>
            <van-col span="24">
                <img v-for="(img,key) in headerImages"
                     :key="key"
                     :src="dns+img"
                     class="top-Image">
            </van-col>
        </van-row>
        <van-row id="form">
            <van-col span="22" offset="1"  class="form-row">

                <div class="input-control">
                    <label>姓名</label>
                    <input type="text" v-model="orderInfo.userName" placeholder="请输入身份证上的真实姓名">
                </div>
                <div class="input-control">
                    <label>电话</label>
                    <input type="text" v-model="orderInfo.userMobile" placeholder="请输入收货人电话">
                </div>
                <div class="input-control">
                    <label>身份证号</label>
                    <input type="text" v-model="orderInfo.idcard" placeholder="请输入您的身份证号码">
                </div>
                <div class="input-control">
                    <label>收货城市</label>
                    <input type="text" :value="orderInfo.city" @click="handleCityClick()" placeholder="点击选择收货地址">
                </div>
                <div class="input-control">
                    <label>详细地址</label>
                    <input type="text" v-model="orderInfo.userAddress" placeholder="镇+村+街道号/小区名称+楼层/门牌号">
                </div>
                <div class="input-control">
                    <label>备注</label>
                    <input type="textarea" v-model="orderInfo.remark" placeholder="">
                </div>
                <div class="input-control">
                    <span style="color: #07c160;">免费领取流量卡，每人限领一张</span>
                </div>
                <div class="input-control">
                    <van-button type="warning" @click="createOrder" block>立即领取</van-button>
                </div>
            </van-col>
        </van-row>
        <van-row>
            <img v-for="(img,key) in footerImages"
                 :key="key"
                 :src="dns+img"
                 class="top-Image">
        </van-row>
        <!--<van-row style="font-size: 13px;padding-bottom: .2rem">
            <p>中国电信股份有限公司深圳分公司 </p>
            <p>深圳市博正计算机软件有限公司 </p>
            <p>深圳市龙华区大浪街道高峰社区华荣路企商网创客中心A栋501</p>
        </van-row>-->
        <van-popup
                v-model="showAreaList"
                position="bottom"
                :style="{ height: '40%' }"
        >
            <van-area :area-list="areaJs"
                      @cancel="showAreaList=false"
                      @confirm="handleCityConfirm"
            />
        </van-popup>
    </div>
</template>
<script>
    import areaJs from "../../plugins/area"

    export default {
        data() {
            return {
                activeKey:0,
                showAreaList:false,
                areaJs: areaJs,
                showIDcardInput:false,
                showIVerifyCodeInput:false,
                orderInfo: {
                    userName:'',
                    phoneProvince:'',
                    phoneCity:'',
                    userProvince:'',
                    userCity:'',
                    userCounty:'',
                    page:'刷宝'
                },
                codeSended:false,
                codeSendBtntext:'',
                dns:'',
                headerImages:[],
                footerImages:[],
                background:'#fff',
                convertId:0
            };
        },
        computed: {
            showUserCity(){
                return  this.orderInfo.userProvince + this.orderInfo.userCity + this.orderInfo.userCounty
            },
        },
        created() {
            this.getSiteInfo();
            this.checkH5PayResult();
        },
        watch: {
            "orderInfo.userName"(){
                if(this.orderInfo.userName.length > 0){
                    this.showIDcardInput = true;
                }
            },
            "orderInfo.userMobile"(){
                if(this.orderInfo.userMobile.length > 0){
                    this.showIVerifyCodeInput = true;
                }
            },
        },
        mounted() {

        },
        methods: {
            getSiteInfo(){
                this.fetchData('/config/siteInfo',{},(res)=>{
                    this.convertId = res.data.convertId
                    this.dns = res.data.dns;
                    this.headerImages = res.data.style.headers
                    this.footerImages = res.data.style.footers;
                    this.background = res.data.style.background
                    this.$nextTick(()=>{
                        document.querySelector('#form').scrollIntoView();
                    })
                })
            },
            createOrder() {
                let reg = /1\d{10}/;
                if (!reg.test(this.orderInfo.userMobile)) {
                    this.$toast.fail('手机号码错误');
                    return false;
                }
                if (!this.orderInfo.idcard || this.orderInfo.idcard.length != 18) {
                    this.$toast.fail('请输入正确的身份证号码');
                    return false;
                }
                if (!this.orderInfo.userName) {
                    this.$toast.fail('请输入收件人姓名');
                    return false;
                }
                if (!this.orderInfo.city) {
                    this.$toast.fail('请选择收件城市');
                    return false;
                }
                if (!this.orderInfo.userAddress) {
                    this.$toast.fail('请输入收件详细地址');
                    return false;
                }
                this.$toast.loading('下单中');
                this.fetchDataPost('/Promote/promotepage', this.orderInfo, (res) => {
                    this.$toast.loading().clear();
                    if (res.code) {
                        this.$toast.success(res.msg)
                    } else {
                        this.$toast.fail(res.msg);
                    }
                })

            },
            handleCityClick(){
                event.target.blur();
                this.showAreaList = true
            },

            handleCityConfirm(obj) {
                this.orderInfo.city='';
                for (let i in obj){
                    this.orderInfo.city += obj[i].name
                }
                this.showAreaList = false
            },
            checkH5PayResult(){
                const orderSn = this.$route.query.orderSn
                if (orderSn) {
                    this.$dialog.alert({
                        message: '请确认微信支付是否已经完成',
                        showConfirmButton: true,
                        showCancelButton: true,
                        confirmButtonText: '支付完成',
                        confirmButtonColor: '#63ce54',
                        cancelButtonText: '支付失败',
                        cancelButtonColor: '#666',
                        confirm() {
                            console.log(1)
                        }
                    }).then(() => {
                        this.$toast.loading('支付确认中')
                        this.fetchData('/Promote/queryPaymentKSH5', {orderSn: orderSn}, (res) => {
                            this.$toast.loading().clear();
                            if (res.code) {
                                this.$toast.success('支付成功，请等待发货');
                                utq('track', 'FormSubmit', '484356');
                                console.log(1)
                            } else {
                                this.$toast.fail(res.msg);
                            }
                        })

                    }).catch(() => {
                        console.log('cancel')
                    });
                }
            }

        }
    };
</script>
<style scoped lang="scss">
    #app{
        padding: 0;
    }
    p{
        margin: 0;
        padding: 0;
    }
    .top-Image{
        width: 100%;
    }
    .tab-nav{
        margin-bottom: .2rem;
    }
    .form-row{
        border-radius: .4rem;
        padding-bottom: .4rem;
    }
    .number-list{
        padding-top: .4rem;
        padding-bottom: .4rem;
        .van-button{
            font-size: .3rem;
            color: #3c7eff;
        }
    }
    .super-number .van-button{
        color: red!important;
        .super-tag {
            position: absolute;
            top: -10px;
            right: -10px;
        }
    }
    .input-control{
        background: #fff;
        label{
            display: block;

            font-weight: bolder;
            text-align: left;
        }
        input{
            border:none;
            display: block;
            width: 100%;
            height: .68rem;
            line-height: .68rem;
            border-bottom: 1px solid #ccc;
        }
        padding: .1rem .3rem;
        margin: auto;
        font-size: .3rem;
        &:first-child{
            padding: .2rem .3rem;
            border-radius: .4rem .4rem 0 0;
        }
        &:last-child{
            border-radius: 0 0 .4rem .4rem;
            border-bottom: none;
            padding: .6rem;
        }
        .van-field{
            padding: 0;
            height: .68rem;
            border-bottom: 1px solid #ccc;
        }
    }
    .main {
        background: #fe822a;
        /*padding-bottom: 1rem;*/
    }

    .goods-detail-row {
        margin-top: .4rem;
    }

    .goods-detail-row .van-icon {
        color: #ed6a0c;
    }

    .buy-info {
        padding: 0 .2rem;
        margin-top: .6rem;
    }

    .buy-info .buy-info-floor {
        font-size: .24rem;
        color: #333;
        font-weight: bolder;
    }

    .buy-info-floor-goods-info {
        margin-top: .4rem;
    }

    .buy-info-floor-goods-info .van-image {
        float: left;
    }

    .buy-info-floor-goods-info .title {

        font-size: .24rem;
    }

    .buy-info-floor-goods-info .title .price-stock {
        margin-top: .3rem;
    }

    .buy-info-floor-goods-info .title .price-stock .price {
        color: #ee3d2c;
        font-size: .32rem;
    }

    .buy-info-floor-goods-info .title .price-stock .stock {
        float: right;
        color: #999;
    }

    .showModal {
        position: absolute;
        width: 4.4rem;
        top: .6rem;
        left: 0;
        height: .7rem;
        text-indent: .1rem;
        padding-right: .1rem;
        -webkit-animation: modalmove 2s ease infinite;
        -o-animation: modalmove 2s ease infinite;
        animation: modalmove 2s ease infinite;
        @keyframes modalmove {
            from{
                left: -4.4rem;
                opacity: 0;
            }
            to{
                left: 0;
                opacity: 1;
            }
        }
    }

    .showModalModal {
        background: #444;
        opacity: .4;
        height: .7rem;
        border-bottom-right-radius: .4rem;
        border-top-right-radius: .4rem;

    }

    .showModal span {
        float: left;
        opacity: 1;
        color: #fff;
        font-size: .26rem;
        text-align: right;
        line-height: .7rem;
        z-index: 1050;
    }

    .address-form {
        padding: 0 .2rem;
    }

    .fixed-bottom {
        position: fixed;
        bottom: 0;
        background: #fff;
        /*width: 7.1rem;
        padding-bottom: 0 .2rem .2rem .2rem;*/
        width: 100%;
        padding:.2rem 0;
        z-index:1050
    }

    .fixed-bottom .van-button--warning {
        width: 2.4rem;
        float: left;
    }

    .fixed-bottom .van-button--danger {
        display: block;
        width: 4.5rem;
        /*float: right;*/
        margin: auto;
    }
</style>



// WEBPACK FOOTER //
// src/pages/kuaishou/promotePage01.vue